import styled from "styled-components";

import { Modal } from "components/Modal";

export const UpgradePremiumModalContainer = styled(Modal)`
  &.modal-wrapper {
    z-index: 10000;
  }

  .modal-content {
    .modal-body {
      margin-top: -30px;
      text-align: center;
      padding: 0 10px;

      img {
        margin-bottom: 20px;
      }

      p {
        font-size: 14px;
        font-weight: 400;
      }

      .button-wrapper {
        display: flex;
        gap: 15px;

        button {
          width: 50%;
          font-size: 14px;
          font-weight: 600;
          padding: 8px 0;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .modal-content .modal-body .button-wrapper button {
      height: 100%;
    }
  }
`;
